<template>
    <ProductSlideshow :title="$t('Related products')" :products="products" />
</template>
<script setup lang="ts">
import ProductSlideshow from '~/components/organisms/ProductSlideshow.vue';

const {
    productId
} = defineProps<{
    productId: number
}>()

const catalogService = useCatalogService()

const {
    data,
    pending
} = await useAsyncData(
    `related-products-${productId}`,
    () => catalogService.getRelatedProducts(productId),
    {
        default: () => ({ data: [] }),
        lazy: true,
        server: false
    }
)

const products = computed(() => data.value.data)
</script>